import { collection, doc, deleteDoc, updateDoc } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { DeleteArticleDetailsParams } from "../types";

export const deleteArticleDetails = async ({
  brandId,
  categoryId,
  groupId,
  articleId,
}: DeleteArticleDetailsParams) => {
  const groupRef = collection(db, "legalDocuments", brandId, categoryId);

  const documentsRef = collection(groupRef, groupId, "documents");

  const articleDocRef = doc(documentsRef, articleId);

  const groupDocRef = doc(groupRef, groupId);

  try {
    await Promise.all([
      deleteDoc(articleDocRef),
      updateDoc(groupDocRef, {
        updatedAt: new Date(),
      }),
    ]);
  } catch (error) {
    console.error("Failed to delete the article:", error);
    throw error;
  }
};
